// Community Photos Redux Saga
import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actions from "./actions";
import { fetchArchivesRequest } from "../archives/actions";

// ==================== SHARE PHOTO ====================

function* sharePhoto(action) {
    try {
        const { archiveId, showUploader } = action.payload;

        const result = yield call(
            AxiosPost,
            `/mycore/${archiveId}/share-community/`,
            { show_uploader: showUploader }
        );

        yield put(actions.sharePhotoSuccess(result.data.message));

        // Refresh archives list to show updated status
        yield put(fetchArchivesRequest());

    } catch (e) {
        const errorMessage = e.response?.data?.error || e.message || 'Failed to share photo';
        yield put(actions.sharePhotoFailure(errorMessage));
    }
}

// ==================== UNSHARE PHOTO ====================

function* unsharePhoto(action) {
    try {
        const { archiveId } = action.payload;

        const result = yield call(
            AxiosPost,
            `/mycore/${archiveId}/unshare-community/`
        );

        yield put(actions.unsharePhotoSuccess(archiveId));

        // Refresh archives list to show updated status
        yield put(fetchArchivesRequest());

    } catch (e) {
        const errorMessage = e.response?.data?.error || e.message || 'Failed to unshare photo';
        yield put(actions.unsharePhotoFailure(errorMessage));
    }
}

// ==================== FETCH COMMUNITY GALLERY ====================

function* fetchCommunityGallery(action) {
    try {
        const filters = action.payload || {};
        const queryParams = new URLSearchParams();

        // Build query string
        Object.keys(filters).forEach(key => {
            if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
                queryParams.append(key, filters[key]);
            }
        });

        const queryString = queryParams.toString();
        const url = `/mycore/community-gallery/${queryString ? `?${queryString}` : ''}`;

        const result = yield call(AxiosCall, url);
        yield put(actions.fetchCommunityGallerySuccess(result.data));

    } catch (e) {
        const errorMessage = e.response?.data?.error || e.message || 'Failed to load community gallery';
        yield put(actions.fetchCommunityGalleryFailure(errorMessage));
    }
}

// ==================== INCREMENT PHOTO VIEW ====================

function* incrementPhotoView(action) {
    try {
        const { archiveId } = action.payload;

        const result = yield call(
            AxiosPost,
            `/mycore/${archiveId}/increment-view/`
        );

        yield put(actions.incrementPhotoViewSuccess(archiveId, result.data.views));

    } catch (e) {
        // Silently fail for view increments - not critical
        yield put(actions.incrementPhotoViewFailure(e.message));
    }
}

// ==================== ROOT SAGA ====================

export default function* communitySaga() {
    yield all([
        takeLatest(actions.SHARE_PHOTO.REQUEST, sharePhoto),
        takeLatest(actions.UNSHARE_PHOTO.REQUEST, unsharePhoto),
        takeLatest(actions.FETCH_COMMUNITY_GALLERY.REQUEST, fetchCommunityGallery),
        takeLatest(actions.INCREMENT_PHOTO_VIEW.REQUEST, incrementPhotoView),
    ]);
}
